/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsHoopCategory
 */
export interface MelcoModelsHoopCategory {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoopCategory
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoopCategory
     */
    name?: string | null;
}

export function MelcoModelsHoopCategoryFromJSON(json: any): MelcoModelsHoopCategory {
    return MelcoModelsHoopCategoryFromJSONTyped(json, false);
}

export function MelcoModelsHoopCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsHoopCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function MelcoModelsHoopCategoryToJSON(value?: MelcoModelsHoopCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


